export default __webpack_public_path__ + "static/media/Atlanticlogo.5ec84032.svg";